/* AUTH */
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGOUT_USER = 'LOGOUT_USER';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const INIT_USER_FROM_COOKIES = 'INIT_USER_FROM_COOKIES';
